import { Grid } from '@mui/material'

import Features from '@ecm/ui/component/menu/Features'
import Products from '@ecm/ui/component/menu/Products'

const ProductsContent = () => (
  <Grid
    data-testid="products-dropdown-content"
    container
    alignItems="flex-start"
    justifyContent="start"
    wrap="nowrap"
    m="2.5em 0 1.5em"
  >
    <Products />
    <Features />
  </Grid>
)

export default ProductsContent
